import axios from '../../../libs/axios_csrf';
import moment from 'moment';
import {extendObservable, computed} from 'mobx';
import {validateEmail} from '../functions';

export default class AffiliationStore {
	constructor(rootStore, invitations, memberships, roles, permissions) {
        roles = roles.filter(e => e != 'ceo')
		this.rootStore = rootStore;
		extendObservable(this, {
			invitations: invitations,
            memberships: memberships,
			roles: roles,
            formEmail: '',
            canManage: permissions['can_manage_invitations']
		})
        this.removeObject = this.removeObject.bind(this);
	}

    formEmailChange(email) {
        this.formEmail = email;
    }

    @computed
    get disabledButton() {
        return !validateEmail(this.formEmail) || this.sendedEmail || this.currentMember
            && this.invitations.length >= 0;
    }

    removeObject(id) {
        this.invitations = this.invitations.filter(e => e.id != id);
        axios.delete(`/invitations/` + id).then(
            (response) => {
            }).catch((e) => console.log(e));
        return Promise.resolve();
    }

    resendEmail(id, role) {
        this.invitations = this.invitations.filter(e => e.id != id);
        axios.delete(`/invitations/` + id).then(
            (response) => {
                this.sendEmail(role);
            }).catch((e) => console.log(e));
    }

    addObject(object) {
        this.invitations.push(object);
    }

    updateObject(email, updatedObject) {
        let currentObject = this.invitations.find(e => e['email'] == email);
        Object.assign(currentObject, updatedObject);
    }

    @computed
    get sendedEmail() {
        return this.invitations.find(e => e["email"] == this.formEmail) !== undefined;
    }

    @computed
    get currentMember() {
        return this.memberships.find(e => e.user.email === this.formEmail) !== undefined;
    }

    sendEmail(role) {
        const uuidv4 = require('uuid/v4');
        const temporalId = uuidv4();
        let newObject = {
            accepted: false,
            created_at: moment(),
            email: this.formEmail,
            id: temporalId,
            role: role,
        }

        this.addObject(newObject);
        axios.post(`/invitations/`, newObject).then(
            (response) => {
                let last = response.data['invitation'];
                this.updateObject(last.email, last);
                this.rootStore.generateAlert({
                    type: 'success',
                    headline: 'mail_sent'
                });
            }).catch((e) => console.log(e));
    }
}